'use strict';

var React = require('react');
var IconBase = require('./dist/IconBase.js');

module.exports = function (props) {
    return React.createElement(IconBase, Object.assign({ viewBox: '0 0 1024 1024' }, props, {
        style: { width: '1em' }
    }), React.createElement(
        'g',
        null,
        React.createElement('path', { d: 'M960 256h-896l64-128h352l32 64h416zM500 800c0 58.784 17.008 113.662 46.342 160h-482.342l-64-640h1024l-25.526 255.248c-52.93-46.796-122.436-75.248-198.474-75.248-165.42 0-300 134.58-300 300zM800 576c-123.71 0-224 100.29-224 224s100.29 224 224 224 224-100.29 224-224-100.29-224-224-224zM832 832v128h-64v-128h-128v-64h128v-128h64v128h128v64h-128z' })
    ));
};